<template>
  <div class="results-feedback-block" @click="toggleExpand">
    <div>
      <div class="results-feedback-block-interior">
        <div v-if="position === '1'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/rdpb_gold.svg" />
        </div>
        <div v-else-if="position === '2'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/rdpb_silver.svg" />
        </div>
        <div v-else-if="position == '3'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/rdpb_bronze.svg" />
        </div>
        <div class="results-feedback-block-right">
          <b class="results-feedback-block-title">{{$t('candidate_profiles.rdpb_title')}}
            <b :class="'results-feedback-block-title-top10' + getGradeColour()" v-if="top10">top 10%</b>
          </b>
          <div class="results-feedback-block-text">
            <div :class="isExpanded ? ' ' : 'results-feedback-block-text-short'">
              {{$t('candidate_profiles.rdpb_text')}}
            </div>
            <div v-if="!isExpanded">
              <i class="results-feedback-block-expand">{{$t('candidate_profiles.discover_more')}}</i>
            </div>
          </div>
        </div>
        <div v-if="isExpanded">
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_up.svg" />
        </div>
        <div v-else>
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_down.svg" />
        </div>
      </div>
      <div v-if="isExpanded">
        <div class="module-laboratory">
          <div class="module-block-title">Le mot du labo</div>
          <p class="quote"><span class="quote-icon">
            </span> Résoudre des problèmes, c’est la capacité à identifier et à traiter <strong>efficacement</strong>
            les problèmes ou
            les défis auxquels on est confronté. C'est une compétence essentielle pour comprendre les enjeux d’une
            situation et prendre des décisions <strong>rationnelles</strong>.
            <span class="quote-icon end"></span>
          </p>
        </div>
        <div class="module-advantages">
          <div class="module-block-title"> Les avantages de la résolution de problèmes </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon eye"></i></div>
              <div class="description">Faire preuve d’une capacité d’analyse</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon target"></i></div>
              <div class="description">Définir un plan pour atteindre un objectif</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon glasses"></i></div>
              <div class="description">Être en capacité de résoudre un problème seul</div>
            </div>
          </div>
        </div>
        <div class="module-advices">
          <div class="module-block-title"> Comment améliorer votre résolution de problèmes </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon plus-minus"></i></div>
              <div class="description">S’exercer à travers des jeux pouvant revêtir de multiples formes : jeux de
                société, jeu de logique et de réflexion, jeux vidéos</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon perspective"></i></div>
              <div class="description">Essayer d’aborder les problèmes sous différentes perspectives</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['position', 'top10'],
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getGradeColour() {
      var iconClass = " ";
      switch (this.position) {
        case '1':
          iconClass += "or-gradient";
          break;
        case '2':
          iconClass += "argent-gradient";
          break;
        case '3':
          iconClass += "bronze-gradient";
          break;
        default:
          break;
      }
      return iconClass;
    }
  }
};
</script>